import { gql } from '@apollo/client'

const MutationAddVirtualAssetFiles = gql(`
    mutation addVirtualAssetFiles($input: [AssetFileInput],  $project: String, $module: String) {
        addVirtualAssetFiles(
            input: $input,
            project: $project
            module: $module
        ) {
            id
            assetId
            mediaId
            # tags
            fileName
            fileSize
            url
            name
            createdAt
            createdBy
            updatedAt
            isArchived
            # category
        }
    }`
)

export default MutationAddVirtualAssetFiles
